import { Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/admin/AdminAuth";
import { CollectionEditPage, CollectionListPage, SingletonEditPage } from "@/admin/CollectionPages";
import ChangePasswordPage from "@/admin/ChangePasswordPage";
import ContactSubmissionsPage from "@/admin/ContactSubmissionsPage";
import DashboardPage from "@/admin/DashboardPage";
import LoginPage from "@/admin/LoginPage";
import { ProductEditPage, ProductsListPage } from "@/admin/ProductsPages";
import QuoteRequestsPage from "@/admin/QuoteRequestsPage";
import ToastHost from "@/admin/Toast";

function Protected({ children }) {
  const { me, loading } = useAdminAuth();
  if (loading) return null;
  if (!me) return <Navigate to="/admin/login" replace />;
  return children;
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="" element={<Protected><DashboardPage /></Protected>} />
      <Route path="pages" element={<Protected><CollectionListPage name="pages" /></Protected>} />
      <Route path="pages/:key" element={<Protected><CollectionEditPage name="pages" /></Protected>} />
      <Route path="services" element={<Protected><CollectionListPage name="services" /></Protected>} />
      <Route path="services/:key" element={<Protected><CollectionEditPage name="services" /></Protected>} />
      <Route path="industries" element={<Protected><CollectionListPage name="industries" /></Protected>} />
      <Route path="industries/:key" element={<Protected><CollectionEditPage name="industries" /></Protected>} />
      <Route path="news" element={<Protected><CollectionListPage name="news_posts" /></Protected>} />
      <Route path="news/:key" element={<Protected><CollectionEditPage name="news_posts" /></Protected>} />
      <Route path="projects" element={<Protected><CollectionListPage name="projects" /></Protected>} />
      <Route path="projects/:key" element={<Protected><CollectionEditPage name="projects" /></Protected>} />
      <Route path="products" element={<Protected><ProductsListPage /></Protected>} />
      <Route path="products/new" element={<Protected><ProductEditPage mode="create" /></Protected>} />
      <Route path="products/:id" element={<Protected><ProductEditPage mode="edit" /></Protected>} />
      <Route path="quote-requests" element={<Protected><QuoteRequestsPage /></Protected>} />
      <Route path="gallery" element={<Protected><CollectionListPage name="gallery_items" /></Protected>} />
      <Route path="gallery/:key" element={<Protected><CollectionEditPage name="gallery_items" /></Protected>} />
      <Route path="navigation" element={<Protected><SingletonEditPage name="navigation" title="Navigation" /></Protected>} />
      <Route path="footer" element={<Protected><SingletonEditPage name="footer_config" title="Footer" /></Protected>} />
      <Route path="site-settings" element={<Protected><SingletonEditPage name="site_settings" title="Site settings" /></Protected>} />
      <Route path="contact-submissions" element={<Protected><ContactSubmissionsPage /></Protected>} />
      <Route path="change-password" element={<Protected><ChangePasswordPage /></Protected>} />
    </Routes>
  );
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminRoutes />
      <ToastHost />
    </AdminAuthProvider>
  );
}
